{
  "steplist": "قائمة الخطوات"
}
